import constants from "./constants";
import { createReducer, updateObject } from "../../utils/reduxHelper";

const initialState = {
  postLoading: false,
  postSuccess: false,
  postError: null,

  getHappinessLoading: false,
  getHappinessSuccess: false,
  getHappinessError: null,
  happinessData: [],

  getUserInfoLoading: false,
  getUserInfoSuccess: false,
  getUserInfoError: null,
  currentOverviewUser: [],
};

/**
 * Post new Entry
 */
const postBegin = state => updateObject(state, { postLoading: true });
const postSuccess = state =>
  updateObject(state, {
    postLoading: false,
    postError: null,
    postSuccess: true,
  });
const postFailure = (state, action) =>
  updateObject(state, { postLoading: false, postError: action.payload });

/**
 * Get Happiness
 */
const getHappinessBegin = state =>
  updateObject(state, { getHappinessLoading: true });
const getHappinessSuccess = (state, action) =>
  updateObject(state, {
    getHappinessLoading: false,
    getHappinessError: null,
    getHappinessSuccess: true,
    happinessData: action.payload,
  });
const getHappinessFailure = (state, action) =>
  updateObject(state, {
    getHappinessLoading: false,
    getHappinessError: action.payload,
  });

/**
 * Get User
 */
const getUserInfoBegin = state =>
  updateObject(state, { getUserInfoLoading: true });
const getUserInfoSuccess = (state, action) =>
  updateObject(state, {
    getUserInfoLoading: false,
    getUserInfoError: null,
    getUserInfoSuccess: true,
    currentOverviewUser: action.payload,
  });
const getUserInfoFailure = (state, action) =>
  updateObject(state, {
    getUserInfoLoading: false,
    getUserInfoError: action.payload,
  });

const handlers = {};
handlers[constants.POST_BEGIN] = postBegin;
handlers[constants.POST_SUCCESS] = postSuccess;
handlers[constants.POST_FAILURE] = postFailure;

handlers[constants.GET_HAPPINESS_BEGIN] = getHappinessBegin;
handlers[constants.GET_HAPPINESS_SUCCESS] = getHappinessSuccess;
handlers[constants.GET_HAPPINESS_FAILURE] = getHappinessFailure;

handlers[constants.GET_USER_BEGIN] = getUserInfoBegin;
handlers[constants.GET_USER_SUCCESS] = getUserInfoSuccess;
handlers[constants.GET_USER_FAILURE] = getUserInfoFailure;

const diaryReducer = createReducer(initialState, handlers);

export default diaryReducer;



// WEBPACK FOOTER //
// ./src/modules/diary/reducer.js